import { Store } from "./store.js";

export class BuyNewClothes extends Store{
    static info = {
        key: "buy-new-clothes",
        name: "Buy new lucky clothes for LNY",
        description: "Time to find a new lucky outfit for the big Lunar New Year celebration. Wearing red is said to bring good luck for the new year. Follow Pei Pei’s directions to look for the items to complete your outfit. Make sure to look for the lucky celebration color!",
        logo: { x: 530, y: 520 },
        won: false
    }
    constructor(key, level){
        super(key, level, { holder: true })
        this._pickables = {
            group: null,
            shadow: null,
            list: [
                {
                    name: "bnlc-red-pants",
                    position: { left: 1650, top: 1230 },
                    peipei: {
                        take: "Go find your lucky red outfit for the celebration! Go find red pants!"
                    }
                },
                {
                    name: "bnlc-red-shorts",
                    position: { left: 2280, top: 1910 },
                    peipei: {
                        take: "Go find a pair of red shorts!"
                    }
                },
                {
                    name: "bnlc-red-sweater",
                    position: { left: 1204, top: 2347 },
                    peipei: {
                        take: "Go find a red sweater!"
                    }
                },
                {
                    name: "bnlc-red-tshirt",
                    position: { left: 2527, top: 1180 },
                    peipei: {
                        take: "Go find a red t-shirt"
                    }
                },
                {
                    name: "bnlc-red-socks",
                    position: { left: 512, top: 435 },
                    peipei: {
                        take: "Go find red socks"
                    }
                },
                {
                    name: "bnlc-red-tanktop",
                    position: { left: 2910, top: 1410 },
                    peipei: {
                        take: "Go find a red tanktop"
                    }
                }
            ]
        }
        this._decoys = {
            group: null,
            list: [
                {
                    "name": "bnlc-a-clothes",
                    "positions": {"left": 512, "top": 606},
                },
                {
                    "name": "bnlc-b-clothes1",
                    "positions": {"left": 887, "top": 440},
                },
                {
                    "name": "bnlc-b-clothes2",
                    "positions": {"left": 1196, "top": 587},
                },
                {
                    "name": "bnlc-c-clothes1",
                    "positions": {"left": 1554, "top": 421},
                },
                {
                    "name": "bnlc-c-clothes2",
                    "positions": {"left": 1767, "top": 269},
                },
                {
                    "name": "bnlc-d-clothes1",
                    "positions": {"left": 2199, "top": 456},
                },
                {
                    "name": "bnlc-d-clothes2",
                    "positions": {"left": 2365, "top": 456},
                },
                {
                    "name": "bnlc-d-clothes3",
                    "positions": {"left": 2626, "top": 335},
                },
                {
                    "name": "bnlc-d-clothes4",
                    "positions": {"left": 2771, "top": 229},
                },
                {
                    "name": "bnlc-g-clothing",
                    "positions": {"left": 896, "top": 1484},
                },
                {
                    "name": "bnlc-h-clothes",
                    "positions": {"left": 1650, "top": 1405},
                },
                {
                    "name": "bnlc-i-clothes1",
                    "positions": {"left": 2225, "top": 1180},
                },
                {
                    "name": "bnlc-i-clothes2",
                    "positions": {"left": 2380, "top": 1437},
                },
                {
                    "name": "bnlc-i-clothes3",
                    "positions": {"left": 2527, "top": 1305},
                },
                {
                    "name": "bnlc-i-clothes4",
                    "positions": {"left": 2375, "top": 1180},
                },
                {
                    "name": "bnlc-j-clothes",
                    "positions": {"left": 3070, "top": 1410},
                },
                {
                    "name": "bnlc-k-clothes",
                    "positions": {"left": 532, "top": 2073},
                },
                {
                    "name": "bnlc-l-clothes1",
                    "positions": {"left": 862, "top": 2157},
                },
                {
                    "name": "bnlc-l-clothes2",
                    "positions": {"left": 1029, "top": 2347},
                },
                {
                    "name": "bnlc-l-clothes3",
                    "positions": {"left": 1362, "top": 2161},
                },
                {
                    "name": "bnlc-m-clothes1",
                    "positions": {"left": 1688, "top": 2164},
                },
                {
                    "name": "bnlc-m-clothes2",
                    "positions": {"left": 1826, "top": 2344},
                },
                {
                    "name": "bnlc-n-clothes",
                    "positions": {"left": 2441, "top": 1910},
                },
                {
                    "name": "bnlc-o-clothes",
                    "positions": {"left": 2297, "top": 2358},
                },
                {
                    "name": "bnlc-p-clothes",
                    "positions": {"left": 2975, "top": 2339},
                }
            ]
        }
        this._totalStars = null
    }
    preload(){
        super.preload()
        this._decoys.list.forEach(c => this.load.image(c.name, `assets/buy-new-clothes/store-clothes/${c.name}.png`))
        this._pickables.list.forEach(c => this.load.image(c.name, `assets/buy-new-clothes/bob-clothes/${c.name}.png`))
    }
    create(){
        super.create()
        this._decoys.group = this.physics.add.staticGroup()
        this._decoys.list.forEach(c => this._decoys.group.create(c.positions.left, c.positions.top, c.name).setOrigin(0).refreshBody())
        this._pickables.group = this.physics.add.staticGroup()
        this._pickables.shadow = this.physics.add.staticGroup()
        this._pickables.list.forEach(c => {
            this._pickables.group.create(c.position.left, c.position.top, c.name).setOrigin(0).refreshBody()
            this._pickables.shadow.create(0, 0, c.name).setVisible(false)
        })
        this._totalStars = this._pickables.list.length * this._GAME_ACTION_POINT
        this.board.score.setText(`0/${this._totalStars}`)
        this._holder.take(this._pickables.shadow.getChildren()[0])
    }
    onSpace(){
        if (!this._holder.holding()) return
        const decoyOverlaps = this._decoys.group.children.entries.filter(c => this.physics.overlapRect(c.x - 45, c.y - 55, c.width + 90, c.height + 55, true, false).length !== 0)
        if (decoyOverlaps.length !== 0) {
            this.peiPeiSay("Oops! That's not what we're looking for.")
            this.sound.play("wrong")
            return
        }
        const overlaps = this._pickables.group.children.entries.filter(c => this.physics.overlapRect(c.x - 55, c.y - 65, c.width + 110, c.height + 65, true, false).length !== 0)
        if (overlaps.length !== 1) return
        const found = overlaps[0]
        if (found.texture.key !== this._holder.item.texture.key) {
            this.peiPeiSay("Oops! That’s not what we’re looking for.")
            this.sound.play("wrong")
            return
        }
        this.sound.play("right");
        found.destroy()
        this.board.score.setText(`${parseInt(this.board.score.text) + 5}/${this._totalStars}`)
        if (this.bob) this.say("Well Done!")
        if (this._pickables.shadow.getChildren().length !== 0) {
            this._holder.empty().take(this._pickables.shadow.getChildren()[0])
            this.sound.play("grabbed-object")
            return
        }
        this.win(this.board.score.text)
        this.peiPeiSay("Mission Accomplished!")
    }
}